import type { CanFrame } from './types';

export function exportFramesJson(frames: CanFrame[]) {
  return JSON.stringify({
    exportedAt: new Date().toISOString(),
    frameCount: frames.length,
    frames
  }, null, 2);
}
